// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Enum_Extra = require("../Data.Enum.Extra/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Extra = require("../Data.Functor.Extra/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Specular_Dom_Builder_Class = require("../Specular.Dom.Builder.Class/index.js");
var Specular_Dom_Widget = require("../Specular.Dom.Widget/index.js");
var Specular_FRP_Base = require("../Specular.FRP.Base/index.js");
var Specular_FRP_Replaceable = require("../Specular.FRP.Replaceable/index.js");
var Specular_FRP_WeakDynamic = require("../Specular.FRP.WeakDynamic/index.js");
var Unsafe_Coerce = require("../Unsafe.Coerce/index.js");
var Utils_JQuery = require("../Utils.JQuery/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var Enabled = (function () {
    function Enabled() {

    };
    Enabled.value = new Enabled();
    return Enabled;
})();
var Disabled = (function () {
    function Disabled() {

    };
    Disabled.value = new Disabled();
    return Disabled;
})();
var DownloadButtonOptions = (function () {
    function DownloadButtonOptions(value0) {
        this.value0 = value0;
    };
    DownloadButtonOptions.create = function (value0) {
        return new DownloadButtonOptions(value0);
    };
    return DownloadButtonOptions;
})();
var Info = (function () {
    function Info() {

    };
    Info.value = new Info();
    return Info;
})();
var $$Error = (function () {
    function $$Error() {

    };
    $$Error.value = new $$Error();
    return $$Error;
})();
var Success = (function () {
    function Success() {

    };
    Success.value = new Success();
    return Success;
})();
var Warning = (function () {
    function Warning() {

    };
    Warning.value = new Warning();
    return Warning;
})();
var Alert = (function () {
    function Alert(value0) {
        this.value0 = value0;
    };
    Alert.create = function (value0) {
        return new Alert(value0);
    };
    return Alert;
})();
var whitespace = function (dictMonadWidget) {
    return Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())(" ");
};
var visibleIfDyn = function (dictMonadWidget) {
    return function (dynCond) {
        return function (inner) {
            return Specular_FRP_Replaceable.weakDynamic_(dictMonadWidget.MonadReplace2())(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(Data_Functor.mapFlipped(Specular_FRP_WeakDynamic.functorWeakDynamic)(dynCond)(function (cond) {
                if (cond) {
                    return inner;
                };
                return Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit);
            }));
        };
    };
};
var testId = function (x) {
    return Foreign_Object.singleton("data-testid")(x);
};
var specularToDomNode = Unsafe_Coerce.unsafeCoerce;
var primaryButton = Foreign_Object.singleton("class")("btn btn-primary");
var mkAlert = function (alertType) {
    return function (message) {
        return new Alert({
            alertType: alertType,
            message: message
        });
    };
};
var successAlert = mkAlert(Success.value);
var warningAlert = mkAlert(Warning.value);
var labeledForm = function (dictMonadWidget) {
    return function (txt) {
        return function (control) {
            return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("label")(Foreign_Object.singleton("class")("control-label"))(Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())(txt)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.el(dictMonadWidget.MonadDomBuilder0())("br")(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit)))(function () {
                    return control;
                });
            });
        };
    };
};
var itemToIndex = function (dictEnum) {
    return function (dictBounded) {
        return function (dictBoundedEnum) {
            return function (item) {
                return Data_Maybe.fromJust()(Data_Array.elemIndex((dictBounded.Ord0()).Eq0())(item)(Data_Enum_Extra.allEnumValues(dictBounded)(dictBoundedEnum.Enum1())));
            };
        };
    };
};
var infoAlert = mkAlert(Info.value);
var errorAlert = mkAlert($$Error.value);
var enumSelectConfig$prime = function (dictEnum) {
    return function (dictBounded) {
        return function (dictBoundedEnum) {
            return function (showF) {
                return function (item) {
                    return function (attrs) {
                        return {
                            options: Data_Enum_Extra.allEnumValues(dictBounded)(dictBoundedEnum.Enum1()),
                            initialValueIndex: itemToIndex(dictBoundedEnum.Enum1())(dictBounded)(dictBoundedEnum)(item),
                            display: showF,
                            attributes: attrs
                        };
                    };
                };
            };
        };
    };
};
var enumSelectConfig = function (dictEnum) {
    return function (dictBounded) {
        return function (dictBoundedEnum) {
            return function (dictShow) {
                return enumSelectConfig$prime(dictBoundedEnum.Enum1())(dictBounded)(dictBoundedEnum)(Data_Show.show(dictShow));
            };
        };
    };
};
var enabled$prime = Foreign_Object.empty;
var elDynAttrClickPreventDefault = function (dictMonadWidget) {
    return function (tagName) {
        return function (attrs) {
            return function (inner) {
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr'"](dictMonadWidget.MonadDomBuilder0())(tagName)(attrs)(inner))(function (v) {
                    return Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (event) {
                        return Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Web_Event_Event.preventDefault(event));
                    })("click")(v.value0);
                });
            };
        };
    };
};
var elAttrClickPreventDefault = function (dictMonadWidget) {
    return function (tagName) {
        return function (attrs) {
            return function (inner) {
                return elDynAttrClickPreventDefault(dictMonadWidget)(tagName)(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs))(inner);
            };
        };
    };
};
var elAttrClick = function (dictMonadWidget) {
    return function (tagName) {
        return function (attrs) {
            return function (inner) {
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr'"](dictMonadWidget.MonadDomBuilder0())(tagName)(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs))(inner))(function (v) {
                    return Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (v1) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                    })("click")(v.value0);
                });
            };
        };
    };
};
var domToSpecularNode = Unsafe_Coerce.unsafeCoerce;
var runWidgetInJQuery = function (jq) {
    return function (widget) {
        var v = Data_Array.head(Utils_JQuery.toArray(jq));
        if (v instanceof Data_Maybe.Just) {
            return Data_Functor.map(Effect.functorEffect)(Data_Tuple.fst)(Specular_Dom_Widget.runWidgetInNode(domToSpecularNode(v.value0))(widget));
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Effect_Exception["throw"]("runWidgetInJQuery: Element not found: " + Data_Show.show(Data_Show.showString)(Utils_JQuery.selector(jq)));
        };
        throw new Error("Failed pattern match at Specular.Dom.Extra (line 63, column 3 - line 66, column 88): " + [ v.constructor.name ]);
    };
};
var disabled$prime = Foreign_Object.singleton("disabled")("true");
var toControlStateAttr = function (v) {
    if (v instanceof Disabled) {
        return disabled$prime;
    };
    return Foreign_Object.empty;
};
var fileDownloadButton = function (dictMonadWidget) {
    return function (v) {
        var mkParamInput = function (v1) {
            return Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("input")(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("type")("hidden"))(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("name")(v1.value0))(Foreign_Object.singleton("value")(v1.value1))))(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit));
        };
        return Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("form")(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("action")(v.value0.url))(Foreign_Object.singleton("method")("get")))(Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Data_Foldable.traverse_((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableArray)(mkParamInput)(v.value0.params))(function () {
            return Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("button")(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("type")("submit"))(toControlStateAttr(v.value0.state)))(Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())(v.value0.label));
        }));
    };
};
var controlButton = function (controlStateWeak) {
    return Control_Apply.apply(Specular_FRP_WeakDynamic.applyWeakDynamic)(Data_Functor.map(Specular_FRP_WeakDynamic.functorWeakDynamic)(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString)))(Data_Functor.map(Specular_FRP_WeakDynamic.functorWeakDynamic)(toControlStateAttr)(controlStateWeak)))(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(primaryButton)(Foreign_Object.singleton("type")("submit"))));
};
var alertIconSign = function (v) {
    if (v instanceof Info) {
        return Foreign_Object.singleton("class")("icon-info-sign");
    };
    if (v instanceof $$Error) {
        return Foreign_Object.singleton("class")("icon-exclamation-sign");
    };
    if (v instanceof Success) {
        return Foreign_Object.singleton("class")("icon-ok-sign");
    };
    if (v instanceof Warning) {
        return Foreign_Object.singleton("class")("icon-warning-sign");
    };
    throw new Error("Failed pattern match at Specular.Dom.Extra (line 152, column 1 - line 152, column 36): " + [ v.constructor.name ]);
};
var alertClass = function (v) {
    if (v instanceof Info) {
        return Foreign_Object.singleton("class")("alert alert-info");
    };
    if (v instanceof $$Error) {
        return Foreign_Object.singleton("class")("alert alert-danger");
    };
    if (v instanceof Success) {
        return Foreign_Object.singleton("class")("alert alert-success");
    };
    if (v instanceof Warning) {
        return Foreign_Object.singleton("class")("alert alert-warning");
    };
    throw new Error("Failed pattern match at Specular.Dom.Extra (line 146, column 1 - line 146, column 33): " + [ v.constructor.name ]);
};
var alertBlock = function (dictMonadWidget) {
    return function (alertWeak) {
        return Specular_FRP_Replaceable.weakDynamic_(dictMonadWidget.MonadReplace2())(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(Data_Functor_Extra["with"](Specular_FRP_WeakDynamic.functorWeakDynamic)(alertWeak)(function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit);
            };
            if (v instanceof Data_Maybe.Just) {
                return Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("div")(alertClass(v.value0.value0.alertType))(Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("a")(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("class")("close"))(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("data-dismiss")("alert"))(Foreign_Object.singleton("href")("#"))))(Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())("x")))(function () {
                    return Specular_Dom_Builder_Class.el(dictMonadWidget.MonadDomBuilder0())("span")(Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.elAttr(dictMonadWidget.MonadDomBuilder0())("i")(alertIconSign(v.value0.value0.alertType))(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())("    "))(function () {
                            return Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())(v.value0.value0.message);
                        });
                    }));
                }));
            };
            throw new Error("Failed pattern match at Specular.Dom.Extra (line 164, column 35 - line 172, column 29): " + [ v.constructor.name ]);
        }));
    };
};
var actionVisibleIfDyn = function (dictMonadWidget) {
    return function (dynCond) {
        return function (inner) {
            return Data_Functor.map((((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Specular_FRP_WeakDynamic.switchWeakDyn)(Specular_FRP_Replaceable.weakDynamic(dictMonadWidget.MonadReplace2())(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(Data_Functor.mapFlipped(Specular_FRP_WeakDynamic.functorWeakDynamic)(dynCond)(function (cond) {
                if (cond) {
                    return inner;
                };
                return Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Specular_FRP_Base.never);
            })));
        };
    };
};
module.exports = {
    runWidgetInJQuery: runWidgetInJQuery,
    elAttrClick: elAttrClick,
    elAttrClickPreventDefault: elAttrClickPreventDefault,
    elDynAttrClickPreventDefault: elDynAttrClickPreventDefault,
    whitespace: whitespace,
    domToSpecularNode: domToSpecularNode,
    specularToDomNode: specularToDomNode,
    actionVisibleIfDyn: actionVisibleIfDyn,
    visibleIfDyn: visibleIfDyn,
    testId: testId,
    fileDownloadButton: fileDownloadButton,
    DownloadButtonOptions: DownloadButtonOptions,
    Enabled: Enabled,
    Disabled: Disabled,
    Info: Info,
    "Error": $$Error,
    Success: Success,
    Warning: Warning,
    Alert: Alert,
    mkAlert: mkAlert,
    infoAlert: infoAlert,
    errorAlert: errorAlert,
    successAlert: successAlert,
    warningAlert: warningAlert,
    alertClass: alertClass,
    alertIconSign: alertIconSign,
    alertBlock: alertBlock,
    toControlStateAttr: toControlStateAttr,
    primaryButton: primaryButton,
    controlButton: controlButton,
    labeledForm: labeledForm,
    "enumSelectConfig'": enumSelectConfig$prime,
    enumSelectConfig: enumSelectConfig,
    itemToIndex: itemToIndex
};
//# sourceMappingURL=index.js.map
